module.exports = __webpack_public_path__ + "static/media/IMG_2082.adea5913.JPG";